import React from 'react';
import {HtmlTag, MarginBottom, TextColor, TextVariant} from './typography.types';

interface TextProps {
  children: React.ReactNode;
  as?: HtmlTag;
  className?: string;
  color?: TextColor;
  marginBottom?: MarginBottom;
  variant?: TextVariant;
}

const variantClasses: Record<TextVariant, string> = {
  [TextVariant.BODY]: 'text-base',
  [TextVariant.BODY_SMALL]: 'text-sm',
  [TextVariant.CAPTION]: 'text-xs',
};

const colorClasses: Record<TextColor, string> = {
  [TextColor.MUTED]: 'text-gray-500',
  [TextColor.PRIMARY]: 'text-gray-900',
  [TextColor.SECONDARY]: 'text-gray-600',
};

const marginClasses: Record<MarginBottom, string> = {
  [MarginBottom.NONE]: 'mb-0',
  [MarginBottom.SM]: 'mb-2',
  [MarginBottom.MD]: 'mb-4',
};

export const Text: React.FC<TextProps> = ({
  as: Tag = HtmlTag.P,
  children,
  className = '',
  color = TextColor.PRIMARY,
  marginBottom,
  variant = TextVariant.BODY,
}) => {
  const marginClass = marginBottom != null ? marginClasses[marginBottom] : '';
  return <Tag className={`${variantClasses[variant]} ${colorClasses[color]} ${marginClass} ${className}`.trim()}>{children}</Tag>;
};
